import { ENDPOINTS } from '../../constants/api'
import { madeRequest } from '../../helpers/api'
import { replaceRouteParams } from '../../helpers/url'
import { CreateAdServerPayload, UpdateAdServerPayload } from '../types/adServer'

type RightId = string | number

export function getAdServerListService() {
  return madeRequest('GET', {
    url: ENDPOINTS.adServerAccess
  })
}

export async function createAdServerService(serverData: CreateAdServerPayload['serverData']) {
  return madeRequest('POST', {
    data: serverData,
    url: ENDPOINTS.adServerAccess
  })
}

export async function updateAdServerService({
  id,
  ...updateAdServerData
}: UpdateAdServerPayload['updateAdServerData']) {
  return madeRequest('PATCH', {
    data: updateAdServerData,
    url: `${ENDPOINTS.adServerAccess}${id}/`
  })
}

export function getAdServerLineItemsService({ rightId }: { rightId: RightId }) {
  return madeRequest('GET', {
    url: replaceRouteParams(ENDPOINTS.adServerLineItems, {
      rightId
    })
  })
}
